import { render, staticRenderFns } from "./ConfigTableMenu.vue?vue&type=template&id=6159102d&"
import script from "./ConfigTableMenu.vue?vue&type=script&lang=js&"
export * from "./ConfigTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports